import { Grid, Typography } from '@material-ui/core';
import { css } from '@emotion/react';
import { i18n } from 'lib/i18n';
import { RCActivityTime } from 'types/coreEntites/Venue';
import { getDatesRange, getActivityDayTime } from 'lib/dates';
import { useRouter } from 'next/router';
import { useColors } from 'hooks/useColors';
import { IColors } from 'types/colors';

const nameCss = (colors: IColors) => css`
	&.MuiTypography-root {
		font-weight: normal;
		color: ${colors.tx_text_primary};
		font-size: 18px;
		text-transform: uppercase;
	}
`;

const containerCss = (colors: IColors) => css`
	.MuiGrid-item {
		margin: 10px 0;
	}
	cursor: pointer;
	height: 100%;
	background-color: ${colors.bg_background_primary};
	padding: 32px 25px;
`;

const detailTitleCss = (colors: IColors) => css`
	&.MuiTypography-root {
		color: ${colors.tx_background_overlay};
		font-size: 10px;
		font-weight: 600;
	}
`;

const detailValueCss = (colors: IColors) => css`
	&.MuiTypography-root {
		color: ${colors.tx_text_primary};
		font-size: 16px;
		font-weight: normal;
	}
`;

const priceValueCss = (colors: IColors) => css`
	&.MuiTypography-root {
		color: ${colors.tx_system};
		font-size: 28px;
		font-weight: normal;
		min-height: 57px;
	}
`;

interface Props {
	id: number;
	leagueId: number;
	name: string;
	startDate: string;
	endDate: string;
	price?: number;
	registrationStartDate?: Date;
	activityTimes?: RCActivityTime[];
}

const detail = (title: string, value: string, colors: IColors, isPrice?: boolean) => (
	<Grid item sm={12}>
		<Typography css={detailTitleCss(colors)}>{title}</Typography>
		<Typography css={isPrice ? priceValueCss(colors) : detailValueCss(colors)}>{value}</Typography>
	</Grid>
);
export default function SeasonBox({
	id,
	leagueId,
	name,
	startDate,
	endDate,
	price,
	registrationStartDate,
	activityTimes,
}: Props) {
	const router = useRouter();
	const { colors } = useColors();
	const { leagueSeoName } = router.query;

	const clickSeasonHandler = () => {
		if (leagueSeoName) {
			router.push(`/activity/leagues/${encodeURIComponent(String(leagueSeoName))}/${leagueId}/season/${id}`);
		}
	};

	return (
		<Grid css={containerCss(colors)} container onClick={clickSeasonHandler}>
			<Typography css={nameCss(colors)}>{name}</Typography>
			{registrationStartDate &&
				detail(i18n.programs.registration.starts, getDatesRange(`${registrationStartDate}`), colors)}
			{detail(i18n.programs.season.dates, getDatesRange(`${startDate}`, `${endDate}`), colors)}
			{activityTimes &&
				detail(
					i18n.event.eventTime,
					getActivityDayTime(
						activityTimes.map(time => time.dayOfWeek - 2),
						activityTimes[0].open,
						activityTimes[0].close
					),
					colors
				)}
			{detail(price ? i18n.leagues.startingAt : '', price ? `$${price}` : '', colors, true)}
			{/* {price && detail(i18n.leagues.startingAt, `$${price}`, colors, true)} */}
		</Grid>
	);
}
